

// import dans le template
// import comme import
// notifier en Export
// 4 mentions par composants


<template>
    <div id="app">
        <header-v/>
        <menuV/>
        <introV/>
        <portfolio msg="Bienvenue sur ma page"/> 
        <contactV/>
        <footerV/>
    </div>
</template>

<script>

  import headerV from './components/headerV.vue'
  import menuV from './components/menuV.vue'
  import IntroV from './components/IntroV.vue'
  import portfolio from './components/portfolio.vue'
  import contactV from './components/contactV.vue'
  import footerV from './components/footerV.vue'


  export default {
    name: 'App',
    components: {
      headerV, menuV, IntroV, portfolio, contactV, footerV
    }
  }

</script>

<style>

/* #app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: red;

} */
</style>
